<div class="homepage-sip-banner-1" [ngClass]="{'animation_mobile': animation && isMobile}">
  <img class="tax" src="/assets/images/tax_benefit_new.gif" alt="tax">
  <div class="container">
    <button class="btn"><span class="btn-text">Donate Monthly</span> <span class="material-icons">navigate_next</span></button>
    <div *ngIf="!isMobile" class="content">
      <div class="title">Be a Hero: Save a Child every month</div>
      <div class="text">With your support, countless children will receive healthcare - start making a difference today</div>
    </div>
    <div *ngIf="isMobile" class="mobile-content">
      <div class="content-1">
        <div class="title">Be a Hero: Save a Child every month</div>
        <img src="/assets/images/sad_child.png" alt="child">
      </div>
      <div class="text">With your support, <strong>countless</strong> children will receive healthcare - start making a difference today</div>
    </div>
    <img class="child_image" *ngIf="!isMobile" src="/assets/images/sad_child.png" alt="child">
  </div>
</div>

